import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined'
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined'
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined'
import RefreshIcon from '@mui/icons-material/Refresh'
import React from 'react'
import { Link } from 'react-router-dom'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { ChevronRightIcon } from '../../../template/kartera/icons'
import { AUTOMATIONS_HELP_URL, formatCount } from '../common/automation-common'
import { useAutomationListModel } from './automation-list-model'

const outlineBtnClass = 'inline-flex h-11 items-center gap-2 rounded-xl border border-k-line bg-k-surface px-4 text-sm font-semibold text-k-ink hover:bg-k-hover'

const AutomationList = () => {
    const model = useAutomationListModel()

    return (
        <KarteraAdminTemplate loading={false} title="Automatizaciones">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                <KarteraPageHeader
                    title="Automatizaciones"
                    description="Procesos de sincronización automática con los portales de las aseguradoras y las pólizas que importaron."
                    actions={(
                        <>
                            <a href={AUTOMATIONS_HELP_URL} target="_blank" rel="noreferrer" className={outlineBtnClass}>
                                <HelpOutlineIcon style={{ fontSize: 18 }} />
                                Ayuda
                            </a>
                            <button type="button" className={outlineBtnClass} onClick={model.reload}>
                                <RefreshIcon className={model.loading ? 'animate-spin' : ''} style={{ fontSize: 18 }} />
                                Actualizar
                            </button>
                        </>
                    )}
                />

                {model.error && (
                    <div className="flex items-center gap-3 rounded-[14px] bg-k-danger-soft px-4 py-3.5 text-sm text-k-danger-ink">
                        <ErrorOutlineIcon style={{ fontSize: 20 }} />
                        <p className="m-0">{model.error}</p>
                    </div>
                )}

                {model.loading && (
                    <div className="flex flex-col gap-2" aria-busy="true">
                        {[1, 2, 3].map((row) => <div key={row} className="h-[76px] animate-pulse rounded-[14px] bg-k-line-soft" />)}
                    </div>
                )}

                {!model.loading && !model.error && model.rows.length === 0 && (
                    <section className="k-card items-start">
                        <h2 className="k-card-title">Sin procesos</h2>
                        <p className="m-0 text-sm text-k-ink-2">
                            Aún no hay procesos de sincronización registrados. Aparecerán aquí cuando actives la sincronización automática en tus claves de agente y se ejecute el primer evento.
                        </p>
                        <Link to="/configuracion/claves" className="text-sm font-bold text-k-primary-ink hover:underline">Ir a claves de agente</Link>
                    </section>
                )}

                {!model.loading && model.rows.length > 0 && (
                    <section className="k-card">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <h2 className="k-card-title">Listado de procesos</h2>
                            <span className="text-xs font-semibold tabular-nums text-k-muted">{formatCount(model.rows.length)} procesos · {formatCount(model.totalPolicies)} pólizas</span>
                        </div>
                        <ul className="m-0 flex list-none flex-col gap-2 p-0">
                            {model.rows.map((row) => (
                                <li key={row.id}>
                                    <button
                                        type="button"
                                        onClick={() => model.openLog(row.id)}
                                        className="group flex w-full items-center gap-3.5 rounded-[14px] border border-k-line bg-k-surface px-4 py-3 text-left hover:border-k-line-strong hover:bg-k-hover"
                                    >
                                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-tone-teal text-tone-teal-ink">
                                            <PrecisionManufacturingOutlinedIcon style={{ fontSize: 22 }} />
                                        </span>
                                        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                                            <span className="truncate text-sm font-bold text-k-ink">{row.aseguradora}</span>
                                            <span className="text-xs tabular-nums text-k-muted">{row.fecha}</span>
                                        </span>
                                        <span className="flex flex-col items-end">
                                            <span className="text-base font-extrabold tabular-nums text-k-ink">{formatCount(row.total)}</span>
                                            <span className="text-xs text-k-muted">pólizas importadas</span>
                                        </span>
                                        <ChevronRightIcon className="shrink-0 text-k-muted-2 group-hover:text-brand-indigo" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </section>
                )}
            </div>
        </KarteraAdminTemplate>
    )
}

export default AutomationList
